import React from 'react';
import { DataItem } from '../types/types';
import './DataComponent.css';

const MediaRenderer: React.FC<{ data: DataItem['data']; title: string }> = ({ data, title }) => {
    switch (data.type) {
        case 'image':
            return (
                <img
                    src={data.url}
                    alt={title}
                    onClick={() => window.open(data.url, '_blank')}
                    style={{ cursor: 'pointer' }}
                />
            );
        case 'video':
            return (
                <video controls>
                    <source src={data.url} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            );
        default:
            return null;
    }
};

const DataComponent: React.FC<DataItem> = ({ id, title, data, description }) => {
    return (
        <div className="data-component" id={id}>
            <h3>{title}</h3>
            <p>{description}</p>
            <div className="media-container">
                <MediaRenderer data={data} title={title} />
            </div>
        </div>
    );
};

export { DataComponent, MediaRenderer };
export default DataComponent; 